export default __webpack_public_path__ + "static/festo-teaser-1400b29663fb44e30349a2d5bf9a9d43.jpg";